import { allEventsInSeries } from 'owa-locstrings/lib/strings/alleventsinseries.locstring.json';
import { thisEvent } from 'owa-locstrings/lib/strings/thisevent.locstring.json';
import loc from 'owa-localize';
import EventScope from 'owa-service/lib/contract/EventScope';

import { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';

export default function getForwardMenuItems(
    item: {
        IsRecurring: boolean;
    },
    onForwardClicked: (eventScope: EventScope) => void
): IContextualMenuItem[] {
    var menuItems = item.IsRecurring
        ? [
              {
                  key: 'forward_occurrence',
                  name: loc(thisEvent),
                  onClick: () => {
                      onForwardClicked(EventScope.ThisInstanceOnly);
                  },
              },
              {
                  key: 'forward_series',
                  name: loc(allEventsInSeries),
                  onClick: () => {
                      onForwardClicked(EventScope.AllInstancesInSeries);
                  },
              },
          ]
        : undefined;

    return menuItems;
}
